/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import TaskListView from '../../view/pages/tasks/TaskListView'
import TaskAction from '../../action/task'
import TaskCollectionStore from '../../store/task/TaskCollectionStore'
import TaskSearchConditionStore from '../../store/task/TaskSearchConditionStore'
import RoomOptionsStore from '../../store/room/RoomOptionsWithLoadingStore'
import RoomAction from '../../action/room'
import TaskPaginationStore from '../../store/task/TaskPaginationStore'
import NProgress from 'nprogress'

class TaskListContainer extends Component {
  static getStores() {
    return [TaskSearchConditionStore, TaskCollectionStore, RoomOptionsStore, TaskPaginationStore]
  }

  static calculateState(prevState, props) {
    return {
      condition: TaskSearchConditionStore.getState(),
      tasks: TaskCollectionStore.getState(),
      room_options: RoomOptionsStore.getState(),
      pagination: TaskPaginationStore.getState(),
      ...props
    }
  }

  async componentDidMount() {
    NProgress.start()
    await RoomAction.fetchByUser()
    await TaskAction.onSearch(this.state.condition, this.state.pagination)
    NProgress.done()
  }

  render() {
    return TaskListView(this.state)
  }
}

export default withRouter(Container.create(TaskListContainer, { withProps: true }))
